module.exports = __webpack_public_path__ + "static/Map-e4502665fb2d26be17613a3d45e1a685.svg";